import { Link, router } from '@inertiajs/react'
import type { AssessmentCta } from '@/types/assessment'

interface AssessmentCtaBannerProps {
  cta: AssessmentCta | null
  className?: string
}

const OPEN_STATUS_COPY: Record<'generating' | 'ready', string> = {
  generating: 'Assessment in progress',
  ready: 'Your assessment brief is ready',
}

export function AssessmentCtaBanner({ cta, className }: AssessmentCtaBannerProps) {
  if (!cta) {
    return null
  }

  if (cta.state === 'open') {
    return (
      <div className={className}>
        <div className="flex items-center justify-between gap-4 rounded-card border border-border bg-background p-[18px]">
          <div>
            <p className="mb-1 font-mono text-[11px] uppercase tracking-eyebrow text-primary">
              Hyrin assessment
            </p>
            <p className="font-sans text-[15px] font-semibold text-foreground">
              {OPEN_STATUS_COPY[cta.status]}
            </p>
          </div>
          <Link href="/assessment" className="shrink-0 font-mono text-[12px] text-primary">
            View →
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className={className}>
      <div className="flex flex-col gap-5 rounded-card bg-primary px-6 py-[22px] sm:flex-row sm:items-center sm:gap-6">
        <div className="flex-1">
          <div className="mb-[7px] flex items-center gap-[10px]">
            <span className="font-mono text-[11px] uppercase tracking-eyebrow text-primary-foreground/70">
              Enhance your profile
            </span>
            <span className="rounded-[5px] bg-secondary px-2 py-[5px] font-mono text-[10px] font-bold uppercase tracking-[0.06em] text-primary">
              1 free / account
            </span>
          </div>
          <p className="mb-[5px] font-heading text-[20px] font-bold leading-[1.2] tracking-[-0.01em] text-primary-foreground">
            Take the Hyrin assessment
          </p>
          <p className="max-w-[520px] font-sans text-[14px] leading-[1.45] text-primary-foreground/75">
            A ~45-minute personalized build challenge that turns your claimed skills into assessed
            proof.
          </p>
        </div>
        <div className="sm:shrink-0 sm:text-right">
          <button
            onClick={() => router.post('/assessment')}
            className="h-[46px] w-full whitespace-nowrap rounded-cta bg-background px-[22px] font-sans text-[15px] font-semibold text-primary transition-opacity hover:opacity-90 sm:w-auto"
          >
            Start free assessment
          </button>
          <p className="mt-[9px] font-sans text-[11px] text-primary-foreground/70">
            ~45 min · one attempt included
          </p>
        </div>
      </div>
    </div>
  )
}
